import { render, staticRenderFns } from "./SendBatch.vue?vue&type=template&id=3fb9675c"
import script from "./SendBatch.vue?vue&type=script&lang=js"
export * from "./SendBatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports